// extracted by mini-css-extract-plugin
module.exports = {"label":"WeiLabel_label__2N5k0"};